import RadioGroup from '@components/molecules/RadioGroup';
import { MaritalStatus } from '@graphql/generated';
import {
  MaritalStatusFormResult,
  QuoteInitialForm
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: MaritalStatusFormResult) => void;
  item: QuoteInitialForm;
}

export const maritalStatusOptions = [
  {
    label: 'Solteiro',
    value: MaritalStatus.Single,
  },
  {
    label: 'Casado(a) ou união estável',
    value: MaritalStatus.Married,
  },
  {
    label: 'Divorciado(a) ou Separado(a)',
    value: MaritalStatus.Divorced,
  },
  {
    label: 'Viúvo(a)',
    value: MaritalStatus.Widower,
  },
];

const MaritalStatusForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } =
    useForm<{ maritalStatus: MaritalStatus }>();

  return (
    <Form
      onSubmit={handleSubmit((data) => {
        if (item.conductor)
          onSubmit({
            conductor: {
              ...item.conductor,
              maritalStatus: data.maritalStatus,
            },
          });
      })}
    >
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            name="maritalStatus"
            errorMessage={errors.maritalStatus?.message}
            onSelected={(value) => {
            if (item.conductor)
              onSubmit({
                conductor: {
                  ...item.conductor,
                  maritalStatus: value as MaritalStatus,
                },
              });
            }}
            options={maritalStatusOptions.map((o) => {
              if (o.value === item.conductor?.maritalStatus)
                return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
    </Form>
  );
};

export default MaritalStatusForm;
